import { useEffect, useState } from 'react';

/**
 * True below the app's mobile breakpoint — lg = 1024px, the same cutoff the
 * dashboard shell uses to swap the sidebar for the drawer nav. Extracted from
 * ProScannerDashboard's inline matchMedia so per-screen JS collapses share one
 * breakpoint convention instead of each picking their own.
 */
export function useIsMobile(query = '(max-width: 1023px)'): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}

export default useIsMobile;
